export const primaryColor = "#5d00b4";
export const primaryHoverColor = "#e570e7";
export const secondaryColor = "#50e3c2";
export const secondaryHoverColor = "#22c5a0";
export const primaryGradient = "linear-gradient( 135deg, #5d00b4 0%, #5d00b4 11%, #5d00b4 11%, #5d00b4 30%,#e570e7 100%)";
export const secondaryGradient = "linear-gradient(to bottom, #b4ec51, #429321);";

export const warning = "#f5a623";
export const success = "#7ed321";
export const danger = "#d0021b";